import * as THREE from 'three'
import { ThreeView } from '../View3dWebCad'
import { IconDragControls } from '../controls/IconDragControls';
import { IconWallItemDragControls } from '../controls/IconWallItemDragControls';
import { OctreeManager } from '../Octree/OctreeManager';

export class ModelDragController {

    public controller: IconDragControls | IconWallItemDragControls;
    public handlers: any[];

    public isMouseDown: boolean;

    constructor(private object: THREE.Object3D, private isWallItem: Boolean) {
        this.create();
        this.addEvent();
        this.isMouseDown = false;
    }

    // DragControlsの作成
    private create() {
        const controller = this.isWallItem ? IconWallItemDragControls : IconDragControls;
        this.controller = new controller([this.object], ThreeView.get().wcCameras.camera.me, ThreeView.get().container);
        this.controller.enabled = false;
    }

    // イベントの付与
    private addEvent() {

        const addHandler = (e: string, func)  => {
            this.controller.addEventListener(e, func);
            return () => this.controller.removeEventListener(e, func);
        }

        this.handlers = [
            addHandler('dragstart', e => this.dragStart()),
            addHandler('dragend', e => this.dragend())
        ];
    }

    // イベント削除
    public removeEvent() {
        if (this.handlers == null) return;
        this.handlers.forEach(handler => handler());
        this.controller.dispose();
    }

    private dragStart() {
        this.isMouseDown = true;
        ThreeView.get().pickermanager.hide();
        ThreeView.get().isOperation = true;
    }
    // ドラッグ終了時の処理
    private dragend() {
        this.isMouseDown = false;
        ThreeView.get().isOperation = false;
        ThreeView.get().updateObject(this.object);
        // アイテム選択解除
        ThreeView.get().unSelectedObject();

        ThreeView.get().OctreeManager = new OctreeManager(ThreeView.get().wcItemmgr.houseData);
        // 画角内判定
        ThreeView.get().CameraTarget.getTargets(ThreeView.get().wcCameras.camera.me, ThreeView.get().OctreeManager.nodeStatus);
    }
}
